import { createFileRoute } from "@tanstack/react-router";
import { sciHead } from "@/lib/science/sci-route";
import { m } from "@/paraglide/messages";
import { CalculatorPage } from "@/tools/ppi-calculator/pages/CalculatorPage";

export const Route = createFileRoute("/ppi-calculator")({
  ssr: true,
  head: () =>
    sciHead({
      basePath: "/ppi-calculator",
      title: m.ppi_meta_title(),
      description: m.ppi_meta_description(),
      toolName: m.ppi_tool_name(),
      faqs: [
        { q: m.ppi_faq_q1(), a: m.ppi_faq_a1() },
        { q: m.ppi_faq_q2(), a: m.ppi_faq_a2() },
        { q: m.ppi_faq_q3(), a: m.ppi_faq_a3() },
        { q: m.ppi_faq_q4(), a: m.ppi_faq_a4() },
      ],
    }),
  component: CalculatorPage,
});
